<template>
	<div class="news-popup">
		<img @click="closeSlide" src="@/assets/x.svg" alt="" class="close">
		<div class="n-item">
			<!-- <div class="cover-img"></div> -->
			<div class="right" v-if="NewsData.date">
				<div class="time">
					<div class="year">{{timeConvert(NewsData.date, true)}}</div>
					<div class="date">{{timeConvert(NewsData.date, false)}}</div>
				</div>
				<h2 class="title">{{NewsData.title}}</h2>
			</div>
		</div>

		<div class="share-box" v-show="NewsData.shareLink">
			<a target="_blank" class="fb" :href="`https://www.facebook.com/sharer/sharer.php?u=${NewsData.shareLink}`">
				<img src="/static/assets/share/fb.svg" alt="">
			</a>
			<a target="_blank" class="line" :href="`http://line.me/R/msg/text/?lize%0D%0A${NewsData.shareLink}`">
				<img src="/static/assets/share/line.svg" alt="">
			</a>
			<a target="_blank" class="twitter" :href="`https://twitter.com/home?status=${NewsData.shareLink}`">
				<img src="/static/assets/share/twitter.svg" alt="">
			</a>
		</div>
		<div class="content" v-html="NewsData.content"></div>

	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: "newsPopup",
  data() {
    return {
      NewsData: {},
      _path: ""
    };
  },
  methods: {
    ...mapActions([
      'getNewsContent'
    ]),
    closeSlide() {
      this.$router.push('/event/news')
    },
    timeConvert: function (timestamp, onlyYear) {
      let date = new Date(timestamp)
      if (onlyYear) {
        return date.getFullYear()
      } else {
        return `${date.getMonth() + 1}/${date.getDate()}`
      }
    }
  },
  mounted() {
    this.getNewsContent(this.$route.params.id).then(() => {
      this.NewsData = this.$store.state.news
    })
    this._path = window.location.href;
  },
  components: {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../stylesheet/base.sass'
  @import '../stylesheet/layout.sass'

  .news-popup
    +size(100%, 100%)
    margin: 74px auto
    position: relative
    background-color: white
    top: 0
    left: 0
    z-index: 50
    min-height: 100%
    height: 100%
    overflow: auto
    .close
      +size(38px, 38px)
      position: relative
      right: 48px
      margin-top: 48px
      cursor: pointer
      opacity: 1
    .n-item
      +flexLayout('between', 'row')
      width: 100%
      max-width: 1000px
      margin: 0 auto
      .cover-img
        +size(114px, 64px)
        background-size: cover
        background-position: center
      .right
        +flexLayout('between', 'row')
        flex: 1
        .time
          +flexLayout('start', 'col')
          color: #636363
          font-weight: 600
          padding: 26px
          line-height: 1.3
          width: 150px
          .year
            font-size: 20px
          .date
            font-size: 35px
        .title
          flex: 1
          color: #222222
          font-size: 24px
          letter-spacing: normal
          font-weight: bold
          border: 1px solid #01b6e2
          border-width: 0 0 0 1px
          padding: 26px 26px 26px
    @media screen and (max-width: 900px)
      margin: 35px auto
      .close
        position: absolute
        margin-top: 0
        top: -2px
        right: 25px
      .n-item
        .right
          .time
            width: 120px
            padding-left: 40px
            padding-right: 0px
            .year
              font-size: 16px
            .date
              font-size: 26px
    .content
      width: 100%
      max-width: 1000px
      margin: 0 auto
      font-size: $font-size-3-s
      line-height: 1.3
      letter-spacing: 2px
      padding: 0 40px
      min-height: 1000px
      img
        max-width: 1000px
        margin: 0 auto
    .share-box
      width: 100%
      padding: 0 40px
      line-height: 1.3
      letter-spacing: 2px
      max-width: 1000px
      margin: 0 auto
      img
        width: 30px
        height: 30px
        margin-right: 10px



</style>



// WEBPACK FOOTER //
// src/components/news_content.vue